// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { getListGlobal } from './globalThunk';

export interface IGlobalState {
  isRefreshGlobalList: boolean;
}

export const initialState: IGlobalState = {
  isRefreshGlobalList: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setRefreshGlobalList(state, action) {
      state.isRefreshGlobalList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list global
    builder
      .addCase(getListGlobal.pending, (_state) => {})
      .addCase(getListGlobal.fulfilled, (_state) => {})
      .addCase(getListGlobal.rejected, (_state) => {});
  },
});

// Action
export const globalActions = globalSlice.actions;

// Selectors

// Reducer
const globalReducer = globalSlice.reducer;
export default globalReducer;
